import smoothscroll from 'smoothscroll-polyfill'
import './scripts/vue'

smoothscroll.polyfill()
